import { useSelector } from "react-redux";
import { getIsOffline } from "./selectors";

const useIsOffline = () => {
  const isOffline = useSelector(getIsOffline);
  return isOffline;
};

export default useIsOffline;
